import React, { useEffect, useState } from "react";

function DeleteModal({ software, onConfirm, onCancel, deleting }) {
  const [password, setPassword] = useState("");

  useEffect(() => {
    setPassword("");
  }, [software]);

  if (!software) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.trim()) {
      onConfirm(password);
    }
  };

  return (
    <div className="rs-modal-overlay" onClick={onCancel}>
      <div className="rs-modal" onClick={(e) => e.stopPropagation()}>
        <div className="rs-modal__header">
          <h3 className="rs-modal__title">Yazılımı Sil</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="rs-modal__body">
            <p className="rs-modal__text">
              <strong>{software.name}</strong> yazılımı ve ilişkili dosyalar
              kalıcı olarak silinecek. Bu işlem geri alınamaz.
            </p>
            <label className="rs-label" htmlFor="delete-password">
              Yönetici Şifresi
            </label>
            <input
              id="delete-password"
              type="password"
              className="rs-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifrenizi girin"
              autoFocus
              required
            />
          </div>
          <div className="rs-modal__footer">
            <button
              type="button"
              className="rs-btn rs-btn-ghost"
              onClick={onCancel}
              disabled={deleting}
            >
              Vazgeç
            </button>
            <button
              type="submit"
              className="rs-btn rs-btn-danger"
              disabled={deleting || !password.trim()}
            >
              {deleting ? "Siliniyor..." : "Evet, Sil"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DeleteModal;
